import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IMeetingStatus, IMeetingStatusState } from "./meetingstatusModel";
import {
  createMeetingStatus,
  deleteMeetingStatus,
  getAllActiveMeetingStatus,
  getAllMeetingStatus,
  getMeetingStatusByID,
  MeetingStatusActiveInactive,
  updateMeetingStatus,
} from "./services/meetingstatus.service";

const initialState: IMeetingStatusState = {
  loading: false,
  formLoading: false,
  error: "",
  MeetingStatusList: [],
  MeetingStatusID: null,
  MeetingStatusDetail: {
    meeting_status: "",
    isactive: 1,
  },
};

const meetingstatusSlice = createSlice({
  name: "meetingstatus",
  initialState,
  reducers: {
    clearMeetingStatusDetails: (state) => {
      state.MeetingStatusDetail = initialState.MeetingStatusDetail;
    },
    setMeetingStatusID: (state, action) => {
      state.MeetingStatusID = action.payload;
    },
    clearMeetingStatusID: (state) => {
      state.MeetingStatusID = initialState.MeetingStatusID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllMeetingStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllMeetingStatus.fulfilled,
      (state, action: PayloadAction<IMeetingStatus[]>) => {
        state.loading = false;
        state.MeetingStatusList = action.payload || [];
      }
    );
    builder.addCase(getAllMeetingStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MeetingStatusList = [];
    });
    builder.addCase(getAllActiveMeetingStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveMeetingStatus.fulfilled,
      (state, action: PayloadAction<IMeetingStatus[]>) => {
        state.loading = false;
        state.MeetingStatusList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveMeetingStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MeetingStatusList = [];
    });
    builder.addCase(createMeetingStatus.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createMeetingStatus.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createMeetingStatus.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateMeetingStatus.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateMeetingStatus.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateMeetingStatus.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteMeetingStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteMeetingStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteMeetingStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(MeetingStatusActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(MeetingStatusActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(MeetingStatusActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getMeetingStatusByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getMeetingStatusByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.MeetingStatusDetail = action.payload;
    });
    builder.addCase(getMeetingStatusByID.rejected, (state, action) => {
      state.formLoading = false;
      state.MeetingStatusDetail = initialState.MeetingStatusDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearMeetingStatusDetails,
  setMeetingStatusID,
  clearMeetingStatusID,
} = meetingstatusSlice.actions;
export default meetingstatusSlice.reducer;
